module.exports = __webpack_public_path__ + "static/quiz_mhnn_manger3-52a4174632d4fb90e4e943a0b60c6da9.png";